import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { INSTITUTION_ADVANTAGES, PARENT_ADVANTAGES } from "../../data/smartContent";

const CheckRow = ({ children }) => (
  <div className="flex items-start gap-3.5 border-t border-slate-200 py-5">
    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-isic text-white">
      <Check size={13} strokeWidth={3} />
    </span>
    <span className="text-[15px] leading-relaxed text-slate-700">{children}</span>
  </div>
);

export const SmartAvantaje = () => (
  <section id="avantaje" data-testid="section-avantaje" className="scroll-mt-20 bg-slate-50 py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-isic">Avantajele proiectului</p>
      </Reveal>

      {/* Pentru instituție */}
      <div className="mt-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">Pentru instituție</p>
            <h3 className="mt-3 font-serif text-3xl font-semibold text-ink leading-tight">
              Avantajele oferite instituției de învățământ
            </h3>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Instituția va primi gratuit în cadrul acestui proiect:
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <ul className="space-y-1">
              {INSTITUTION_ADVANTAGES.map((item) => (
                <li key={item}>
                  <CheckRow>{item}</CheckRow>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>

      <div className="my-12 h-px bg-slate-200" />

      {/* Pentru părinți */}
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <Reveal delay={0.1}>
            <div className="grid sm:grid-cols-2 gap-x-10">
              {PARENT_ADVANTAGES.map((item) => (
                <CheckRow key={item}>{item}</CheckRow>
              ))}
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-5 order-1 lg:order-2">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">Pentru părinți</p>
            <h3 className="mt-3 font-serif text-3xl font-semibold text-ink leading-tight">
              Avantajele oferite părinților
            </h3>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Un plus de siguranță și de vizibilitate pentru familiile elevilor.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
